import { extendTheme } from "@chakra-ui/react";


const Custheme = extendTheme({
    colors: {
        black: {
            500: "#000000",
            600: "#1a1a1a",
        },
        orange: {
            500: "#f26722"
        },

    },
});

export default Custheme
